var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"bottom":"","left":"","min-width":"300","max-width":"300","nudge-left":"12","offset-x":"","transition":"slide-y-transition"}})}
var staticRenderFns = []

export { render, staticRenderFns }